var map = {
	"./Dr. A.R.Krishnaraja.jpeg": 88854,
	"./Dr. G. S. Rampradheep.jpeg": 76246,
	"./Dr. S. Balaji.JPG": 2931,
	"./Dr. S. Vinodhkumar.jpeg": 3908,
	"./Dr. S.Karthikeyan.jpg": 90792,
	"./Dr.K.Vishnuvardhan.jpg": 66430,
	"./Dr.P.Kulanthaivel.jpeg": 59899,
	"./Dr.S.Manoj.jpeg": 84101,
	"./Dr.T.Pradeep.jpg": 77945,
	"./Dr.V.SAMPATHKUMAR.jpeg": 13429,
	"./K.S.NAVANEETHAN.jpg": 67705,
	"./Mr.K.Sampath Kumar.jpg": 74516,
	"./Mr.S B Prasath.jpeg": 93560,
	"./Mrs.M.KOWSALYA.jpeg": 9817,
	"./S.Venkatachalam.png": 80131,
	"./T.Ravi Prakash.jpg": 71614,
	"./T.S.Mukesh.jpeg": 91249
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51640;